import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseResponse } from '../models/auth.models';
import { LeadApplicationDto, LeadApplicationRequest, PagedResult } from '../models/admin.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class LeadApplicationsService extends ApiService {
  private publicUrl = environment.apiUrl + '/api/lead-applications';
  private adminUrl = environment.apiUrl + '/api/admin/lead-applications';

  create(data: LeadApplicationRequest): Observable<BaseResponse<{ id: string }>> {
    return this.http.post<BaseResponse<{ id: string }>>(this.publicUrl, data);
  }

  getAll(params: {
    page?: number;
    pageSize?: number;
    search?: string;
    status?: string;
  }): Observable<BaseResponse<PagedResult<LeadApplicationDto>>> {
    let p = new HttpParams().set('page', params.page ?? 1).set('pageSize', params.pageSize ?? 20);
    if (params.search) p = p.set('search', params.search);
    if (params.status) p = p.set('status', params.status);
    return this.http.get<BaseResponse<PagedResult<LeadApplicationDto>>>(this.adminUrl, {
      params: p,
    });
  }

  update(
    id: string,
    data: LeadApplicationRequest & { status: string },
  ): Observable<BaseResponse<void>> {
    return this.http.put<BaseResponse<void>>(`${this.adminUrl}/${id}`, data);
  }
}
